import script from "./agent-desc.vue?vue&type=script&setup=true&lang=js"
export * from "./agent-desc.vue?vue&type=script&setup=true&lang=js"

import "./agent-desc.vue?vue&type=style&index=0&id=3bf80e20&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf80e20"]])

export default __exports__